export default __webpack_public_path__ + "static/media/feature4.ae83f2e4.jpg";